import { DeptName } from 'yxt-open-data/es';

export default DeptName;
